var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationObjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50173 1.68944C8.7859 1.43685 9.21412 1.43685 9.49828 1.68944L16.2483 7.68944C16.5579 7.96463 16.5858 8.43869 16.3106 8.74827C16.0354 9.05786 15.5613 9.08575 15.2517 8.81056L15 8.5868V14.25C15 15.0784 14.3284 15.75 13.5 15.75H4.50001C3.67158 15.75 3.00001 15.0784 3.00001 14.25V8.5868L2.74828 8.81056C2.43869 9.08575 1.96464 9.05786 1.68945 8.74827C1.41426 8.43869 1.44215 7.96463 1.75174 7.68944L8.50173 1.68944ZM4.50001 7.25347V14.25H6.75001V10.5C6.75001 10.0858 7.08579 9.75 7.50001 9.75H10.5C10.9142 9.75 11.25 10.0858 11.25 10.5V14.25H13.5V7.25347L9.00001 3.25347L4.50001 7.25347ZM9.75001 14.25V11.25H8.25001V14.25H9.75001Z",
    fill: "url(#paint0_linear_1014_81825)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1014_81825",
    x1: 5.57143,
    y1: -1.14643,
    x2: 10.6347,
    y2: 18.1228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#499BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C052F3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationObjects);
export default __webpack_public_path__ + "static/media/notification-objects.276d774b1ee6393d110ded2d0e090e46.svg";
export { ForwardRef as ReactComponent };